import React from 'react';
import core, { API } from '@gin-betting/core';

const {
    hooks: { useSubscription },
} = core;

interface Props {
    variables: API.GqlSubscriptionVars['onUpdateSportEvent'];
    origin: string;
    batch: boolean;
}

const SportEventSubscription: React.FC<Props> = ({
    variables,
    batch,
    origin,
}) => {
    useSubscription({
        variables,
        config: {
            method: 'onUpdateSportEvent',
            origin,
            batch,
        },
    });

    return null;
};

export default SportEventSubscription;
